import React from 'react'
import Container from './styles'

const StaffListItem = ({ staff }) => {
  const getInitials = () => {
    return `${staff.firstName?.[0] || ''}${staff.lastName?.[0] || ''}`
  }

  const getRoleBadgeClass = (role) => {
    switch (role) {
      case 'MANAGER':
        return 'manager'
      case 'DISPATCHER':
        return 'dispatcher'
      case 'STAFF':
      default:
        return 'staff'
    }
  }

  return (
    <Container>
      <div className="img--container">
        {getInitials()}
      </div>

      <h3>{staff.fullName || `${staff.firstName} ${staff.lastName}`}</h3>

      <p>{staff.phone}</p>

      <span className={`role-badge ${getRoleBadgeClass(staff.role)}`}>
        {staff.role}
      </span>
    </Container>
  )
}

export default StaffListItem
